import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

const LogoStyled = styled(Link)`
  grid-area: logo;
  justify-self: start;
  align-self: center;
  ${media.lessThan('large')`
    justify-self: center;
  `}
  height: 50px;
  display: block;
  position: relative;
  img {
    border-radius: 50%;
  }
`;

const SiteName = styled.div`
  display: inline-block;
  text-decoration: none;
  font-weight: bold;
  font-size: 2rem;
  color: var(--font-color);

  margin: 0 1rem;
  text-align: center;
  height: 50px;
  line-height: 48px;
`;

type Props = {
  type: Page;
};
const Logo: React.VFC<Props> = ({ type }) => (
  <LogoStyled to="/">
    <StaticImage
      src="../../images/icon.png"
      alt="icon"
      placeholder="blurred"
      width={50}
    />
    <SiteName>KOKI</SiteName>
  </LogoStyled>
);

export default Logo;
